export default __webpack_public_path__ + "static/media/_A6A9927.8239d840.jpg";